import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInheritance = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("desc", { children: "Crafted by hand by Wouter Horré." }), /* @__PURE__ */ _jsx("g", {
		fill: "none",
		stroke: "#4A5666",
		strokeWidth: 1.3,
		children: /* @__PURE__ */ _jsx("path", { d: "m5 10 5-10 5 10zM10 20V10" })
	})]
});
export default SvgInheritance;
